<template>
  <div class="form">
    <el-form ref="form" :rules="rules" :model="RetrievePasswordByPhoneDTO" >
      <div class="form-input">
        <el-row>
          <el-col :span="24">
            <el-form-item class="form_inputs" label="登录账号：" prop="account">
              <el-input placeholder="请输入登录账号" v-model="RetrievePasswordByPhoneDTO.account" style="width:200px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="form_inputs" label="手机号码：" prop="mobilePhone">
              <el-input placeholder="请输入手机号码" v-model="RetrievePasswordByPhoneDTO.mobilePhone" style="width:200px;"></el-input>
              <el-input placeholder="短信验证码" v-model="RetrievePasswordByPhoneDTO.msgCode"></el-input>
              <el-button type="primary" @click="getMsgCode()">获取验证码</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="forget">请使用注册时提交的手机号获取短信验证码。</div>
      <el-form-item>
        <el-button type="primary" @click="cancel()">取消</el-button>
        <el-button type="primary" native-type="submit" @click="submit()">提交</el-button>
      </el-form-item>
    </el-form>
  </div>

</template>
<script>
import axios from 'axios'
import { Message } from 'element-ui'

export default {
  name: 'forget',
  data () {
    return {
      rules: {
        account: [
          { required: true, message: '请输入用户名', trigger: ['blur', 'change'] }
        ],
        mobilePhone: [
          { required: true, message: '请输入手机号', trigger: ['blur', 'change'] }
        ]
      },
      RetrievePasswordByPhoneDTO: {
        account: '',
        mobilePhone: '',
        msgCode: ''
      }
    }
  },
  methods: {
    getMsgCode () {
      axios.post(`${process.env.VUE_APP_SERVER_URL}/ucenter/forget/front/getMsgCode`, this.RetrievePasswordByPhoneDTO)
        .then(function (response) {
          const data = response.data
          if (data.status !== 200) {
            Message({
              message: data.message,
              type: 'warning'
            })
            return
          }
          Message({
            message: '验证码已发送，请注意查收！',
            type: 'success'
          })
        })
    },
    cancel () {
      this.$router.push({ path: '/login' })
    },
    submit () {
      if (!this.RetrievePasswordByPhoneDTO.msgCode) {
        Message({
          message: '请输入验证码',
          type: 'error'
        })
        return
      }
      axios.post(`${process.env.VUE_APP_SERVER_URL}/ucenter/forget/front/sendNewPassword`, this.RetrievePasswordByPhoneDTO)
        .then(function (response) {
          const data = response.data
          if (data.status !== 200) {
            Message({
              message: data.message,
              type: 'warning'
            })
            return
          }
          Message({
            message: '新密码已发送，请注意查收！',
            type: 'success'
          })
        })
    }
  }

}

</script>
<style lang="scss" scoped>
@import '@/assets/css/base.scss';
  .form{
    width: 700px;
    margin: 20px auto;
    .form_inputs{
      display: flex;
    }
    .el-input{
      width: 110px;
      margin-right: 20px;
    }
    .el-row{
      margin-bottom: 30px;
    }
  }

  .forget {
    margin: 40px;
    font-size: 14px;
    color: #d43c33;
  }
</style>
